import React from 'react';
import { MenuIcon } from '../../lib/myIcons.jsx';
import './DashboardHeader.scss';

const DashboardHeader = ({ toggleMenu, title ,variant="user"}) => {
  return (
    // <div className="dashboardHeader">
    <div className={`dashboardHeader dashboardHeader--${variant}`}>
      <div className="menuToggleIcon" onClick={toggleMenu}>
        <MenuIcon size={24} />
      </div>
      <h1 className="dashboardTitle">{title}</h1>
    </div>
  );
};

export default DashboardHeader;
